
            const data = {"name":"glyph/16/small-triangle-right","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"m5 13 6-5-6-5z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    